import React from "react";
import svg75 from "../../assets/svg/svg75.svg";
import svg79 from "../../assets/svg/svg79.svg";
import svg76 from "../../assets/svg/svg76.svg";
import svg77 from "../../assets/svg/svg77.svg";
import svg78 from "../../assets/svg/svg78.svg";

const items = [
  {
    title: "Expanded Farmer Led Irrigation Development",
    subs: "Supporting smallholder farmers with affordable and scalable irrigation tools that empower them to manage their own water resources effectively.",
    svg: "svg75",
  },
  {
    title: "Maximized Community Scheme Benefits",
    subs: "Strengthening community governance and sustainability to ensure that local irrigation systems are well-managed and continue to support food security.",
    svg: "svg79",
  },

  {
    title: "High Performing Public Schemes:",
    subs: "Modernizing and improving the efficiency and governance of existing public irrigation schemes to increase their productivity and sustainability.",
    svg: "svg76",
  },
  {
    title: "Revitalized Irrigation in ASALs",
    subs: "Implementing tailored irrigation solutions designed specifically for arid and semi-arid lands to unlock agricultural potential in these challenging environments.",
    svg: "svg77",
  },
  {
    title: "Enabled Corporate Agribusiness",
    subs: "Encouraging private sector investment in large-scale commercial irrigation projects that drive economic growth and diversification.",
    svg: "svg78",
  },
];
function About() {
  const svgMap = {
    svg75,
    svg79,
    svg76,
    svg77,
    svg78,
  };
  const processedData = items?.map((item) => ({
    ...item,
    svg: svgMap[item?.svg],
  }));

  return (
    <div className="bg-white lg:pt-[6.25rem] pt-4 lg:px-[6.25rem] px-3 w-full">
      <div className="w-full flex flex-col items-center justify-center text-center">
        <span className="lg:w-[38.4375rem] w-full text-[#050505] font-sora lg:text-[2rem] text-[1.75rem] font-[600] leading-normal">
          About State Department for Irrigation
        </span>

        <span className="lg:w-[36rem] w-full  text-[#1A1A1A] font-sora lg:text-[1rem] text-[.85rem] font-[400]">
          Kenya is committed to advancing irrigation through sustainable use of
          land and water to ensure food security and promote socio-economic
          growth.
        </span>
      </div>

      <div className="lg:mt-[5rem] mt-4 w-full  items-center justify-center grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-[2.5rem]">
        {processedData &&
          processedData?.map((item) => (
            <div
              style={{ boxShadow: "0px 4px 25px 0px rgba(7, 6, 18, 0.08)" }}
              className="lg:px-[2.5rem] px-4 pt-[1.25rem] pb-[2.5rem] lg:min-h-[15.8125rem] h-auto rounded-[.75rem]
                  bg-white flex flex-col z-20"
            >
              <img
                className="w-[4.0625rem] h-[4.0625rem]"
                src={item?.svg}
                slt={item?.svg}
              />
              <div className="text-[#050505] font-[400] text-[1rem] font-sora mt-[.62rem]">
                {item?.title}
              </div>

              <div className="text-[#706F6F] font-[400] text-[.875rem] font-sora mt-[.62rem]">
                {item?.subs}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default About;
